import { render } from "./CustomSvgIcon.vue?vue&type=template&id=2a05913e"
import script from "./CustomSvgIcon.vue?vue&type=script&lang=js"
export * from "./CustomSvgIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/danidee/Dev/github/video-downloader-bot-pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
